import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { apiFetch } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { AuthShell, inputCls, primaryBtn } from "@/components/AuthShell";

export default function VerifyEmail() {
  const { refresh, logout } = useAuth();
  const navigate = useNavigate();
  const [code, setCode] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await apiFetch("/auth/verify-email", { method: "POST", body: JSON.stringify({ code: code.trim() }) });
      await refresh();
      toast.success("Email verified!");
      navigate("/");
    } catch (err) {
      toast.error(err.message);
    } finally {
      setLoading(false);
    }
  };

  const resend = async () => {
    try {
      await apiFetch("/auth/resend-code", { method: "POST" });
      toast.success("A new code is on its way");
    } catch (err) {
      toast.error(err.message);
    }
  };

  return (
    <AuthShell
      title="Verify your email"
      subtitle="Enter the 6-digit code we emailed you."
      footer={<button onClick={() => { logout(); navigate("/login"); }} className="font-medium hover:text-price">Use a different account</button>}
    >
      <form onSubmit={submit} className="space-y-4">
        <input
          data-testid="verify-code"
          inputMode="numeric"
          maxLength={6}
          required
          value={code}
          onChange={(e) => setCode(e.target.value.replace(/\D/g, ""))}
          className={`${inputCls} text-center text-2xl tracking-[0.5em]`}
          placeholder="000000"
        />
        <button data-testid="verify-submit" type="submit" disabled={loading} className={primaryBtn}>
          {loading ? "Verifying…" : "Verify"}
        </button>
      </form>
      <button data-testid="resend-code" onClick={resend} className="mt-3 w-full text-sm font-medium text-muted-foreground hover:text-price">
        Resend code
      </button>
    </AuthShell>
  );
}
